import axios from "axios";
export default axios.create({
    baseURL: "https://api.visua.com/",
    headers: {
        "Content-type": "application/json",
    },
    withCredentials: true,
});
